import { Auth0Client } from '@auth0/auth0-spa-js';

export const auth0 = new Auth0Client({
    domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
    authorizationParams: {
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
    },
    cacheLocation: 'localstorage',
});

export const login = async () => {
    try {
        await auth0.loginWithRedirect();
    } catch (error) {
        console.error('Login error:', error);
        throw error;
    }
};

export const logout = async () => {
    try {
        await auth0.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    } catch (error) {
        console.error('Logout error:', error);
        throw error;
    }
};

export const getAccessToken = async () => {
    try {
        const isAuthenticated = await auth0.isAuthenticated();
        if (!isAuthenticated) {
            return null;
        }
        
        // Get token with proper error handling
        const token = await auth0.getTokenSilently();
        return token;
    } catch (error) {
        console.error('Error getting access token:', error);
        
        // Handle specific Auth0 errors that indicate session issues
        if (error && typeof error === 'object' && 'error' in error) {
            const auth0Error = error as { error: string };
            if (auth0Error.error === 'login_required' || 
                auth0Error.error === 'consent_required' || 
                auth0Error.error === 'interaction_required') {
                console.log('Auth0 session expired, user needs to re-authenticate');
                // Don't automatically logout - let the user handle this
                // The Auth0 SDK will handle the session state properly
            }
        }
        
        return null;
    }
};

export const getUser = async () => {
    try {
        const user = await auth0.getUser();
        return user;
    } catch (error) {
        console.error('Error getting user:', error);
        return null;
    }
};

export const isAuthenticated = async () => {
    try {
        const isAuth = await auth0.isAuthenticated();
        return isAuth;
    } catch (error) {
        console.error('Error checking authentication:', error);
        return false;
    }
}; 